<!-- 会员成长体系页 -->
<template>
  <div class='vipGrow'>
    <publicHeader :pageTitle="pageTitle" v-if="!noHeader"></publicHeader>
    <div class="zhanwei" v-if="!noHeader">

    </div>
    <div class="growPic">
      <div class="gorwList">
        <div class="growItem" v-for="(item,index) in growList" :key="index">
          <div class="userHeadImg">
            <img :src="userHeadImg" alt="" sizes="" srcset="" v-if="userIndex===index">
          </div>
          <div class="expre">{{item.expre}}</div>
          <div class="col" :style="{'height':item.height+'rem'}"></div>
          <div class="num">V{{item.num}}</div>
        </div>
      </div>

    </div>
    <div class="grade">
      <div class="title">等级特权</div>
      <div class="gradeTable">
        <table>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">LV{{item.grade}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.expre}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.coupon}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.colorChat}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.horn}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.discount}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.prop}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.birthday}}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in gradeList" :key="index" :class="{'first':index==0}">{{item.miVideo}}</td>
          </tr>

        </table>
      </div>

    </div>
  </div>
</template>

<script>
import publicHeader from '../components/PublicHeader'

export default {
  components: { publicHeader },
  data () {
    return {
      // 当前用户的成长值以及头像
      id: '',
      userHeadImg: '',
      userWealthExp: 0,
      userIndex: 0,
      growList: [{
        num: 0,
        expre: 0,
        height: 0.19
      }, {
        num: 10,
        expre: 55000,
        height: 0.58
      }, {
        num: 20,
        expre: 210000,
        height: 1.04
      }, {
        num: 30,
        expre: 465000,
        height: 1.51
      }, {
        num: 40,
        expre: 820000,
        height: 2
      }, {
        num: 50,
        expre: 1275000,
        height: 2.72
      }],

      gradeList: [
        {
          grade: "等级",
          expre: "经验",
          coupon: "观赛券",
          colorChat: "彩色弹幕",
          horn: "全服喇叭",
          discount: "商品折扣",//
          prop: "进场道具",//
          birthday: "生日祝福",//
          miVideo: "迷视频",//
        }, {
          grade: 1,//等级
          expre: 0,//经验
          coupon: 1,//观赛券
          colorChat: 20,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 2,//等级
          expre: 3000,//经验
          coupon: 1,//观赛券
          colorChat: 40,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 3,//等级
          expre: 6000,//经验
          coupon: 1,//观赛券
          colorChat: 60,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 4,//等级
          expre: 10000,//经验
          coupon: 1,//观赛券
          colorChat: 80,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 5,//等级
          expre: 15000,//经验
          coupon: 1,//观赛券
          colorChat: 100,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 6,//等级
          expre: 21000,//经验
          coupon: 1,//观赛券
          colorChat: 120,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 7,//等级
          expre: 28000,//经验
          coupon: 1,//观赛券
          colorChat: 140,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 8,//等级
          expre: 36000,//经验
          coupon: 1,//观赛券
          colorChat: 160,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 9,//等级
          expre: 45000,//经验
          coupon: 1,//观赛券
          colorChat: 180,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 10,//等级
          expre: 55000,//经验
          coupon: 1,//观赛券
          colorChat: 200,//彩色弹幕
          horn: 0,//全服喇叭
          discount: "9.5折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 11,//等级
          expre: 66000,//经验
          coupon: 3,//观赛券
          colorChat: 220,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 12,//等级
          expre: 78000,//经验
          coupon: 3,//观赛券
          colorChat: 240,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 13,//等级
          expre: 91000,//经验
          coupon: 3,//观赛券
          colorChat: 260,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 14,//等级
          expre: 105000,//经验
          coupon: 3,//观赛券
          colorChat: 280,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 15,//等级
          expre: 120000,//经验
          coupon: 3,//观赛券
          colorChat: 300,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 16,//等级
          expre: 136000,//经验
          coupon: 3,//观赛券
          colorChat: 320,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 17,//等级
          expre: 153000,//经验
          coupon: 3,//观赛券
          colorChat: 340,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 18,//等级
          expre: 171000,//经验
          coupon: 3,//观赛券
          colorChat: 360,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 19,//等级
          expre: 190000,//经验
          coupon: 3,//观赛券
          colorChat: 380,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 20,//等级
          expre: 210000,//经验
          coupon: 5,//观赛券
          colorChat: 400,//彩色弹幕
          horn: 1,//全服喇叭
          discount: "9.2折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 21,//等级
          expre: 231000,//经验
          coupon: 5,//观赛券
          colorChat: 420,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 22,//等级
          expre: 254000,//经验
          coupon: 5,//观赛券
          colorChat: 440,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 23,//等级
          expre: 276000,//经验
          coupon: 5,//观赛券
          colorChat: 460,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 24,//等级
          expre: 300000,//经验
          coupon: 5,//观赛券
          colorChat: 480,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        },
        {
          grade: 25,//等级
          expre: 325000,//经验
          coupon: 5,//观赛券
          colorChat: 500,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 26,//等级
          expre: 351000,//经验
          coupon: 5,//观赛券
          colorChat: 520,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 27,//等级
          expre: 378000,//经验
          coupon: 5,//观赛券
          colorChat: 540,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 28,//等级
          expre: 406000,//经验
          coupon: 5,//观赛券
          colorChat: 560,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 29,//等级
          expre: 435000,//经验
          coupon: 5,//观赛券
          colorChat: 580,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 30,//等级
          expre: 465000,//经验
          coupon: 5,//观赛券
          colorChat: 600,//彩色弹幕
          horn: 3,//全服喇叭
          discount: "9折",//商品折扣
          prop: "无",//进场道具
          birthday: "无",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 31,//等级
          expre: 496000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 32,//等级
          expre: 528000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 33,//等级
          expre: 561000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 34,//等级
          expre: 595000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 35,//等级
          expre: 630000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 36,//等级
          expre: 666000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 37,//等级
          expre: 703000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 38,//等级
          expre: 741000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 39,//等级
          expre: 780000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 40,//等级
          expre: 820000,//经验
          coupon: 10,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 10,//全服喇叭
          discount: "8.5折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 41,//等级
          expre: 861000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 42,//等级
          expre: 903000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 43,//等级
          expre: 946000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 44,//等级
          expre: 990000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 45,//等级
          expre: 1035000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 46,//等级
          expre: 1081000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 47,//等级
          expre: 1128000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 48,//等级
          expre: 1176000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 49,//等级
          expre: 1225000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "无",//迷视频
        }, {
          grade: 50,//等级
          expre: 1275000,//经验
          coupon: 15,//观赛券
          colorChat: "无限",//彩色弹幕
          horn: 20,//全服喇叭
          discount: "8折",//商品折扣
          prop: "有",//进场道具
          birthday: "有",//生日祝福
          miVideo: "有",//迷视频
        },],
      pageTitle: '',
      token: ''
    }
  },
  created () {
    this.noHeader = this.$route.query.noHeader
    console.log(this.noHeader);
    this.getToken()
    this.id = this.$route.query.id
    document.title = '会员成长体系'
    this.pageTitle = '会员成长体系'
    this.changeAppTitle('会员成长体系')
    this.getUserGrowth()
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 获取用户成长值信息
    getUserGrowth () {
      let params = {
        token: this.token,
        vip_id: this.id,
        statistics: this.$CONFIG.statistics
      }
      this.$vipapi.getVipGrowth(params).then(res => {

        if (res.status === 200) {
          this.userHeadImg = res.data.data.userHeadImg
          this.userWealthExp = Number(res.data.data.userWealthExp)
          this.judgeIndex()
        }
      })
    },
    judgeIndex () {
      if (this.userWealthExp > 0 && this.userWealthExp < 55000) {
        this.userIndex = 0
      } else if (this.userWealthExp > 55000 && this.userWealthExp < 210000) {
        this.userIndex = 1
      } else if (this.userWealthExp > 210000 && this.userWealthExp < 465000) {
        this.userIndex = 2
      } else if (this.userWealthExp > 465000 && this.userWealthExp < 820000) {
        this.userIndex = 3
      } else if (this.userWealthExp > 820000 && this.userWealthExp < 1275000) {
        this.userIndex = 4
      } else if (this.userWealthExp > 1275000) {
        this.userIndex = 5
      }
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题', newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题", newtitle)
      }
    }
  },
}
</script>
<style lang='less' scoped>
.vipGrow {
  position: relative;
  // 等级图
  .growPic {
    width: 100%;
    height: 5.5rem;
    background: url('https://images.zhibo.tv/2020/1109/growbg.png') no-repeat;
    background-size: 100%;
    overflow: hidden;

    .gorwList {
      display: flex;
      height: 4.16rem;
      justify-content: space-between;
      margin-top: 0.5rem;
      margin-bottom: 0.55rem;
      padding: 0 0.3rem;
      .growItem {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        // 用户的头像
        .userHeadImg {
          width: 0.7rem;
          height: 0.7rem;
          margin-bottom: 0.13rem;
          border-radius: 50%;
          img {
            display: block;
            width: 0.7rem;
            height: 0.7rem;
            border-radius: 50%;
            border: 0.02rem solid #d8bea4;
          }
        }
        .expre {
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #e4c491;
        }
        .col {
          margin: 0.1rem 0 0.2rem 0;
          width: 0.16rem;
          background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
          border-radius: 0.1rem 0.1rem 0 0;
        }
        .num {
          width: 0.6rem;
          height: 0.35rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 0.14vw solid #e4c491;
          border-radius: 0.1rem;
          color: #e5c28b;

          text-align: center;
          font-size: 0.22rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
    }
  }
  // 等级特权
  .grade {
    margin-top: -0.5rem;
    min-height: 5rem;
    background: #ffffff;
    border-radius: 0.2rem 0.2rem 0 0;
    padding: 0.3rem;
    padding-right: 0;
    overflow: scroll;
    .title {
      margin-bottom: 0.2rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .gradeTable {
      display: flex;
      overflow: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }

      // &::after {
      //   content: '';
      //   display: table;
      //   width: 0.3rem;
      //   height: 1rem;
      // }
      .thList {
        flex-shrink: 0;
        position: sticky;
        left: 0;
        top: 5.84rem;
        .thItem {
          width: 1.77rem;
          height: 0.8rem;
          background: #f7f1e8;
          border-top: 0.17vw solid #eddab8;
          border-left: 0.17vw solid #eddab8;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 0.26rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c2a56a;
        }
        & :last-child {
          border-bottom: 0.17vw solid #eddab8;
        }
      }
    }
    table {
      width: 100%;

      table-layout: fixed;
      word-break: break-all;
      word-wrap: break-word;
      border-top: 0.17vw solid #eddab8;
      border-left: 0.17vw solid #eddab8;
      border-spacing: 0;
      border-collapse: collapse;
      position: relative;
      tr {
        &::after {
          content: '';
          display: block;
          width: 0.3rem;
          height: 100%;
          background: #fff;
          position: absolute;
        }
      }

      td {
        width: 1.77rem;
        height: 0.8rem;
        padding: 0;
        text-align: center;
        border-right: 0.17vw solid #eddab8;
        border-bottom: 0.17vw solid #eddab8;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .first {
        position: sticky;
        left: 0;
        background: #f7f1e8;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c2a56a;
        // border: 1px solid red;
      }
    }
  }
}
</style>
